@if (showFullscreen()) {
  <button mat-fab class="close-button" (click)="closeFullscreen()">
    <mat-icon>close</mat-icon>
  </button>
}

<section>
  <ng-content></ng-content>
</section>
